import { Icons } from 'assets/icons/icons.index';
import { Images } from 'assets/images/images.index';
import { ButtonClose } from 'components/atoms/Button-close/Button-close';
import { Button } from 'components/atoms/Button/Button';
import { PopupOverlay } from 'components/atoms/Popup-overlay/Popup-overlay';
import { TypeState } from 'models/app.interface';
import { ReactNode } from 'react';
import './Popup-informative.scss';

interface IPropsPopUpInformative {
  type: TypeState;
  title: string;
  subtitle?: string;
  text?: string;
  labelButton?: string;
  labelButton2?: string;
  /** When provided, onClickButton3 must also be provided to render the third button */
  labelButton3?: string;
  onClickButton?: () => void;
  onClickButton2?: () => void;
  /** Required when labelButton3 is provided */
  onClickButton3?: () => void;
  closePopUp: () => void;
  children?: ReactNode;
}
export const PopUpInformative = (props: IPropsPopUpInformative) => {
  const setIcon = () => {
    return {
      error: Images.error,
      warning: Images.chipWarning,
      successful: Images.check,
      info: Icons.contactCenter,
    }[props.type];
  };

  return (
    <PopupOverlay>
      <div
        className={`popup__informative__container popup__informative--${props.type}`}
      >
        <ButtonClose
          size="medium"
          className="popup__informative__close"
          onClick={props.closePopUp}
          template={props.type === 'info' ? 'dark' : 'light'}
        />
        <div className="popup__informative__body">
          <img
            className="popup__informative__icon"
            src={setIcon()}
            alt="Icono tipo modal"
          />
          <h2
            className={`popup__informative__title--${props.type}`}
            dangerouslySetInnerHTML={{ __html: props.title }}
          ></h2>
          {props.subtitle && (
            <h6
              className="popup__informative__subtitle"
              dangerouslySetInnerHTML={{ __html: props.subtitle }}
            ></h6>
          )}
          {props.text && (
            <p
              className={`popup__informative__text popup__informative__text--${props.type}`}
              dangerouslySetInnerHTML={{ __html: props.text }}
            ></p>
          )}
          {props.children}
          <div className="popup__informative__buttons">
            {props.labelButton && (
              <Button
                className={`popup__informative__button ${props.type}`}
                type="button"
                size="small"
                template="secondary"
                typeStyle="square"
                isDisabled={false}
                label={props.labelButton}
                color="primary"
                onClick={props.onClickButton}
              />
            )}
            {props.labelButton2 && (
              <Button
                className={`popup__informative__button ${props.type}`}
                type="button"
                size="small"
                template="primary"
                typeStyle="square"
                isDisabled={false}
                label={props.labelButton2}
                color="primary"
                onClick={props.onClickButton2}
              />
            )}
            {props.labelButton3 && props.onClickButton3 && (
              <Button
                className={`popup__informative__button ${props.type}`}
                type="button"
                size="small"
                template="primary"
                typeStyle="square"
                isDisabled={false}
                label={props.labelButton3}
                color="primary"
                onClick={props.onClickButton3}
              />
            )}
          </div>
        </div>
      </div>
    </PopupOverlay>
  );
};
